// Conatiner Component Imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import TanksTableWidget from "../../components/Widgets/tanksTableWidget";

const OrganizationTanksContainer = () => {
  const dispatch = useDispatch();
  const organization = useSelector((state) => state.organization);

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: organization?.name,
          link: "/organization",
        },
        {
          title: "Tanks",
          link: "/tanks",
        },
      ])
    );
  }, [organization]);

  return (
    <>
      
      <TanksTableWidget
        showAddTankButton
        subHeader={"Below is a list of all Tanks within this Organization"}
      />
    </>
  );
};

export default OrganizationTanksContainer;
